<template>
  <div>
    <v-dialog v-model="dialog" max-width="800" persistent>
      <v-card>
        <v-card-title
          primary-title
          style="padding-left: 30px; font-weight: bold; font-size: 28px"
        >
          {{ selected.store_name_th }} ({{ selected.store_name_en }})
        </v-card-title>

        <v-card-text>
          <div style="padding-inline: 15px">
            <div
              style="
                border-style: solid;
                border-radius: 5px;
                border-color: #b6b6b6;
                border-width: 1px;
                padding-block: 25px;
                padding-inline: 10px;
              "
            >
              <v-layout row wrap>
                <v-flex xs6>
                  <div class="text-dec">
                    <h3>Store Name (TH):</h3>
                    {{ selected.store_name_th }}
                  </div></v-flex
                >
                <v-flex xs6>
                  <div class="text-dec">
                    <h3>Store Name (EN):</h3>
                    {{ selected.store_name_en }}
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6>
                  <div class="text-dec">
                    <h3>Store Description (TH):</h3>
                    {{ selected.store_description_th }}
                  </div></v-flex
                >
                <v-flex xs6>
                  <div class="text-dec">
                    <h3>Store Description (EN):</h3>
                    {{ selected.store_description_en }}
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6>
                  <div class="text-dec">
                    <h3>Store Address (TH):</h3>
                    {{ selected.store_address_th }}
                  </div></v-flex
                >
                <v-flex xs6>
                  <div class="text-dec">
                    <h3>Store Address (EN):</h3>
                    {{ selected.store_address_en }}
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6>
                  <div style="padding-inline: 10px">
                    <h3>Store Tel:</h3>
                    {{ selected.store_tel }}
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div style="padding-inline: 10px">
                    <h3>Store E-mail:</h3>
                    {{ selected.store_email }}
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <h3 style="margin-top: 30px">Connect users to dine-in merchant</h3>
            <v-autocomplete
              v-model="selected_user"
              :items="user_merchant"
              item-text="user_full_name"
              item-value="user_id"
              label="Select user merchant"
              multiple
              chips
              :isLoading="isLoadingUserMerchant"
            >
            </v-autocomplete>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions style="padding-block: 15px; padding-inline: 30px">
          <v-btn
            style="padding-inline: 50px; font-weight: 600; letter-spacing: 1px"
            color="error"
            @click="$emit('closeDialog')"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            style="
              padding-inline: 50px;
              font-weight: 600;
              letter-spacing: 1px;
              color: black;
            "
            color="primary"
            :disabled="selected_user.length == 0"
            @click="connectUserMerchant()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="error_dialog" persistent max-width="500">
      <v-card>
        <div
          style="
            background-color: #fddf00;
            height: 60px;
            display: flex;
            align-items: center;
            padding-left: 20px;
          "
        >
          <v-icon large style="margin-right: 10px" color="black"
            >warning</v-icon
          >
          <div style="font-size: 1.8rem">Warning</div>
        </div>
        <v-card-title class="headline" primary-title
          >Something went wrong! Please try again.</v-card-title
        >

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="error_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data: () => ({
    user_merchant: [],
    selected_user: [],
    user_count: 1,
    isLoadingUserMerchant: true,
    error_dialog: false,
  }),
  props: ["dialog", "selected"],
  watch: {
    async dialog() {
      if (this.dialog == true) {
        if (this.selected.store_connect_user_id.length == 0) {
          this.selected_user = [];
          return;
        }
        let select = [];
        for (let val of this.selected.store_connect_user_id) {
          select.push({
            ...val,
            user_full_name: `${val.user_first_name} ${val.user_last_name}`,
          });
        }
        this.selected_user = select;
      }
    },
  },

  created() {
    this.fetchData();
  },
  computed: {
    ...mapState({
      all_user_merchant: (state) => state.fetchStoreApproveBack.merchant_user,
    }),
    ...mapGetters({
      applyNewUserMerchantData:
        "fetchStoreApproveBack/applyNewUserMerchantData",
    }),
  },
  methods: {
    initial() {
      this.fetchData();
    },
    async connectUserMerchant() {
      var body;
      if (typeof this.selected_user[0] !== "number") {
        let formatData = [];
        for (let val of this.selected_user) {
          formatData.push(val.user_id);
        }
        body = {
          store_id: this.selected.store_id,
          user_id: formatData,
        };
      } else {
        body = {
          store_id: this.selected.store_id,
          user_id: this.selected_user,
        };
      }
      var res = await this.$store.dispatch(
        "fetchStoreApproveBack/updateMerchantUser",
        body
      );
      if (res == true) {
        await this.$store.dispatch("fetchStoreApproveBack/getDineInStoreList");
        this.$emit("closeDialog");
      } else {
        this.error_dialog = true;
      }
    },
    async fetchData() {
      this.isLoadingUserMerchant = true;
      await this.$store.dispatch("fetchStoreApproveBack/getMerchantUser");
      this.user_merchant = this.applyNewUserMerchantData;
      this.isLoadingUserMerchant = false;
    },
  },
};
</script>
<style>
.text-dec {
  margin-bottom: 5px;
  padding-inline: 10px;
}
</style>
